"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useComboboxProviderContext } from "../__chunks/3LH6HMTR.js";
import { usePopoverAnchor } from "../__chunks/NWYOIOBE.js";
import { useComposite } from "../__chunks/IKLZZMLE.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import { useBooleanEvent, useEvent, useForceUpdate, useId, useMergeRefs, useSafeLayoutEffect, useUpdateEffect, useUpdateLayoutEffect } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox.tsx
import { getPopupRole, getScrollingElement, getTextboxSelection, setSelectionRange } from "@ariakit/core/utils/dom";
import { isFocusEventOutside, queueBeforeEvent } from "@ariakit/core/utils/events";
import { hasFocus } from "@ariakit/core/utils/focus";
import { invariant, isFalsyBooleanCallback, noop, normalizeString } from "@ariakit/core/utils/misc";
import { sync } from "@ariakit/core/utils/store";
import { useEffect, useMemo, useRef, useState } from "react";
var TagName = "input";
function isFirstItemAutoSelected(items, activeValue, autoSelect) {
  if (!autoSelect) return false;
  var firstItem = items.find(function (item) {
    return !item.disabled && item.value;
  });
  return (firstItem == null ? void 0 : firstItem.value) === activeValue;
}
function hasCompletionString(value, activeValue) {
  if (!activeValue) return false;
  if (value == null) return false;
  value = normalizeString(value);
  return activeValue.length > value.length && activeValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
}
function isInputEvent(event) {
  return event.type === "input";
}
function isAriaAutoCompleteValue(value) {
  return value === "inline" || value === "list" || value === "both" || value === "none";
}
function getDefaultAutoSelectId(items) {
  var item = items.find(function (item2) {
    var _a;
    if (item2.disabled) return false;
    return ((_a = item2.element) == null ? void 0 : _a.getAttribute("role")) !== "tab";
  });
  return item == null ? void 0 : item.id;
}
var useCombobox = createHook(function useCombobox2(_a) {
  var _b = _a,
    store = _b.store,
    _b$focusable = _b.focusable,
    focusable = _b$focusable === void 0 ? true : _b$focusable,
    _b$autoSelect = _b.autoSelect,
    autoSelectProp = _b$autoSelect === void 0 ? false : _b$autoSelect,
    getAutoSelectId = _b.getAutoSelectId,
    setValueOnChange = _b.setValueOnChange,
    _b$showMinLength = _b.showMinLength,
    showMinLength = _b$showMinLength === void 0 ? 0 : _b$showMinLength,
    showOnChange = _b.showOnChange,
    showOnMouseDown = _b.showOnMouseDown,
    _b$showOnClick = _b.showOnClick,
    showOnClick = _b$showOnClick === void 0 ? showOnMouseDown : _b$showOnClick,
    showOnKeyDown = _b.showOnKeyDown,
    _b$showOnKeyPress = _b.showOnKeyPress,
    showOnKeyPress = _b$showOnKeyPress === void 0 ? showOnKeyDown : _b$showOnKeyPress,
    blurActiveItemOnClick = _b.blurActiveItemOnClick,
    _b$setValueOnClick = _b.setValueOnClick,
    setValueOnClick = _b$setValueOnClick === void 0 ? true : _b$setValueOnClick,
    _b$moveOnKeyPress = _b.moveOnKeyPress,
    _moveOnKeyPress = _b$moveOnKeyPress === void 0 ? true : _b$moveOnKeyPress,
    _b$autoComplete = _b.autoComplete,
    autoComplete = _b$autoComplete === void 0 ? "list" : _b$autoComplete,
    props = __objRest(_b, ["store", "focusable", "autoSelect", "getAutoSelectId", "setValueOnChange", "showMinLength", "showOnChange", "showOnMouseDown", "showOnClick", "showOnKeyDown", "showOnKeyPress", "blurActiveItemOnClick", "setValueOnClick", "moveOnKeyPress", "autoComplete"]);
  var context = useComboboxProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "Combobox must receive a `store` prop or be wrapped in a ComboboxProvider component.");
  var ref = useRef(null);
  var _useForceUpdate = useForceUpdate(),
    _useForceUpdate2 = _slicedToArray(_useForceUpdate, 2),
    valueUpdated = _useForceUpdate2[0],
    forceValueUpdate = _useForceUpdate2[1];
  var canAutoSelectRef = useRef(false);
  var composingRef = useRef(false);
  var autoSelect = store.useState(function (state) {
    return state.virtualFocus && autoSelectProp;
  });
  var inline = autoComplete === "inline" || autoComplete === "both";
  var _useState = useState(inline),
    _useState2 = _slicedToArray(_useState, 2),
    canInline = _useState2[0],
    setCanInline = _useState2[1];
  useUpdateLayoutEffect(function () {
    if (!inline) return;
    setCanInline(true);
  }, [inline]);
  var storeValue = store.useState("value");
  var prevSelectedValueRef = useRef();
  useEffect(function () {
    return sync(store, ["selectedValue", "activeId"], function (_, prev) {
      prevSelectedValueRef.current = prev.selectedValue;
    });
  }, []);
  var inlineActiveValue = store.useState(function (state) {
    var _a2;
    if (!inline) return;
    if (!canInline) return;
    if (state.activeValue && Array.isArray(state.selectedValue)) {
      if (state.selectedValue.includes(state.activeValue)) return;
      if ((_a2 = prevSelectedValueRef.current) == null ? void 0 : _a2.includes(state.activeValue)) return;
    }
    return state.activeValue;
  });
  var items = store.useState("renderedItems");
  var open = store.useState("open");
  var contentElement = store.useState("contentElement");
  var value = useMemo(function () {
    if (!inline) return storeValue;
    if (!canInline) return storeValue;
    var firstItemAutoSelected = isFirstItemAutoSelected(items, inlineActiveValue, autoSelect);
    if (firstItemAutoSelected) {
      if (hasCompletionString(storeValue, inlineActiveValue)) {
        var slice = (inlineActiveValue == null ? void 0 : inlineActiveValue.slice(storeValue.length)) || "";
        return storeValue + slice;
      }
      return storeValue;
    }
    return inlineActiveValue || storeValue;
  }, [inline, canInline, items, inlineActiveValue, autoSelect, storeValue]);
  useEffect(function () {
    var element = ref.current;
    if (!element) return;
    var onCompositeItemMove = function onCompositeItemMove() {
      return setCanInline(true);
    };
    element.addEventListener("combobox-item-move", onCompositeItemMove);
    return function () {
      element.removeEventListener("combobox-item-move", onCompositeItemMove);
    };
  }, []);
  useEffect(function () {
    if (!inline) return;
    if (!canInline) return;
    if (!inlineActiveValue) return;
    var firstItemAutoSelected = isFirstItemAutoSelected(items, inlineActiveValue, autoSelect);
    if (!firstItemAutoSelected) return;
    if (!hasCompletionString(storeValue, inlineActiveValue)) return;
    var cleanup = noop;
    queueMicrotask(function () {
      var element = ref.current;
      if (!element) return;
      var _getTextboxSelection = getTextboxSelection(element),
        prevStart = _getTextboxSelection.start,
        prevEnd = _getTextboxSelection.end;
      var nextStart = storeValue.length;
      var nextEnd = inlineActiveValue.length;
      setSelectionRange(element, nextStart, nextEnd);
      cleanup = function cleanup() {
        if (!hasFocus(element)) return;
        var _getTextboxSelection2 = getTextboxSelection(element),
          start = _getTextboxSelection2.start,
          end = _getTextboxSelection2.end;
        if (start !== nextStart) return;
        if (end !== nextEnd) return;
        setSelectionRange(element, prevStart, prevEnd);
      };
    });
    return function () {
      return cleanup();
    };
  }, [valueUpdated, inline, canInline, inlineActiveValue, items, autoSelect, storeValue]);
  var scrollingElementRef = useRef(null);
  var getAutoSelectIdProp = useEvent(getAutoSelectId);
  var autoSelectIdRef = useRef(null);
  useEffect(function () {
    if (!open) return;
    if (!contentElement) return;
    var scrollingElement = getScrollingElement(contentElement);
    if (!scrollingElement) return;
    scrollingElementRef.current = scrollingElement;
    var onUserScroll = function onUserScroll() {
      canAutoSelectRef.current = false;
    };
    var onScroll = function onScroll() {
      if (!store) return;
      if (!canAutoSelectRef.current) return;
      var _store$getState = store.getState(),
        activeId = _store$getState.activeId;
      if (activeId === null) return;
      if (activeId === autoSelectIdRef.current) return;
      canAutoSelectRef.current = false;
    };
    var options = {
      passive: true,
      capture: true
    };
    scrollingElement.addEventListener("wheel", onUserScroll, options);
    scrollingElement.addEventListener("touchmove", onUserScroll, options);
    scrollingElement.addEventListener("scroll", onScroll, options);
    return function () {
      scrollingElement.removeEventListener("wheel", onUserScroll, true);
      scrollingElement.removeEventListener("touchmove", onUserScroll, true);
      scrollingElement.removeEventListener("scroll", onScroll, true);
    };
  }, [open, contentElement, store]);
  useSafeLayoutEffect(function () {
    if (!storeValue) return;
    if (composingRef.current) return;
    canAutoSelectRef.current = true;
  }, [storeValue]);
  useSafeLayoutEffect(function () {
    if (autoSelect !== "always" && open) return;
    canAutoSelectRef.current = open;
  }, [autoSelect, open]);
  var resetValueOnSelect = store.useState("resetValueOnSelect");
  useUpdateEffect(function () {
    var _a2, _b2;
    var canAutoSelect = canAutoSelectRef.current;
    if (!store) return;
    if (!open) return;
    if ((!autoSelect || !canAutoSelect) && !resetValueOnSelect) return;
    var _store$getState2 = store.getState(),
      baseElement = _store$getState2.baseElement,
      contentElement2 = _store$getState2.contentElement,
      activeId = _store$getState2.activeId;
    if (baseElement && !hasFocus(baseElement)) return;
    if (contentElement2 == null ? void 0 : contentElement2.hasAttribute("data-placing")) {
      var observer = new MutationObserver(forceValueUpdate);
      observer.observe(contentElement2, {
        attributeFilter: ["data-placing"]
      });
      return function () {
        return observer.disconnect();
      };
    }
    if (autoSelect && canAutoSelect) {
      var userAutoSelectId = getAutoSelectIdProp(items);
      var autoSelectId = userAutoSelectId !== void 0 ? userAutoSelectId : (_a2 = getDefaultAutoSelectId(items)) != null ? _a2 : store.first();
      autoSelectIdRef.current = autoSelectId;
      store.move(autoSelectId != null ? autoSelectId : null);
    } else {
      var element = (_b2 = store.item(activeId)) == null ? void 0 : _b2.element;
      if (element && "scrollIntoView" in element) {
        element.scrollIntoView({
          block: "nearest",
          inline: "nearest"
        });
      }
    }
    return;
  }, [store, open, valueUpdated, storeValue, autoSelect, resetValueOnSelect, getAutoSelectIdProp, items]);
  useEffect(function () {
    if (!inline) return;
    var combobox = ref.current;
    if (!combobox) return;
    var elements = [combobox, contentElement].filter(function (value2) {
      return !!value2;
    });
    var onBlur2 = function onBlur2(event) {
      if (elements.every(function (el) {
        return isFocusEventOutside(event, el);
      })) {
        store == null ? void 0 : store.setValue(value);
      }
    };
    var _iterator = _createForOfIteratorHelper(elements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        element.addEventListener("focusout", onBlur2);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return function () {
      var _iterator2 = _createForOfIteratorHelper(elements),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;
          element.removeEventListener("focusout", onBlur2);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
  }, [inline, contentElement, store, value]);
  var canShow = function canShow(event) {
    var currentTarget = event.currentTarget;
    return currentTarget.value.length >= showMinLength;
  };
  var onChangeProp = props.onChange;
  var showOnChangeProp = useBooleanEvent(showOnChange != null ? showOnChange : canShow);
  var setValueOnChangeProp = useBooleanEvent(
  // If the combobox is combined with tags, the value will be set by the tag
  // input component.
  setValueOnChange != null ? setValueOnChange : !store.tag);
  var onChange = useEvent(function (event) {
    onChangeProp == null ? void 0 : onChangeProp(event);
    if (event.defaultPrevented) return;
    if (!store) return;
    var currentTarget = event.currentTarget;
    var value2 = currentTarget.value,
      selectionStart = currentTarget.selectionStart,
      selectionEnd = currentTarget.selectionEnd;
    var nativeEvent = event.nativeEvent;
    canAutoSelectRef.current = true;
    if (isInputEvent(nativeEvent)) {
      if (nativeEvent.isComposing) {
        canAutoSelectRef.current = false;
        composingRef.current = true;
      }
      if (inline) {
        var textInserted = nativeEvent.inputType === "insertText" || nativeEvent.inputType === "insertCompositionText";
        var caretAtEnd = selectionStart === value2.length;
        setCanInline(textInserted && caretAtEnd);
      }
    }
    if (setValueOnChangeProp(event)) {
      var isSameValue = value2 === store.getState().value;
      store.setValue(value2);
      queueMicrotask(function () {
        setSelectionRange(currentTarget, selectionStart, selectionEnd);
      });
      if (inline && autoSelect && isSameValue) {
        forceValueUpdate();
      }
    }
    if (showOnChangeProp(event)) {
      store.show();
    }
    if (!autoSelect || !canAutoSelectRef.current) {
      store.setActiveId(null);
    }
  });
  var onCompositionEndProp = props.onCompositionEnd;
  var onCompositionEnd = useEvent(function (event) {
    canAutoSelectRef.current = true;
    composingRef.current = false;
    onCompositionEndProp == null ? void 0 : onCompositionEndProp(event);
    if (event.defaultPrevented) return;
    if (!autoSelect) return;
    forceValueUpdate();
  });
  var onMouseDownProp = props.onMouseDown;
  var blurActiveItemOnClickProp = useBooleanEvent(blurActiveItemOnClick != null ? blurActiveItemOnClick : function () {
    return !!(store == null ? void 0 : store.getState().includesBaseElement);
  });
  var setValueOnClickProp = useBooleanEvent(setValueOnClick);
  var showOnClickProp = useBooleanEvent(showOnClick != null ? showOnClick : canShow);
  var onMouseDown = useEvent(function (event) {
    onMouseDownProp == null ? void 0 : onMouseDownProp(event);
    if (event.defaultPrevented) return;
    if (event.button) return;
    if (event.ctrlKey) return;
    if (!store) return;
    if (blurActiveItemOnClickProp(event)) {
      store.setActiveId(null);
    }
    if (setValueOnClickProp(event)) {
      store.setValue(value);
    }
    if (showOnClickProp(event)) {
      queueBeforeEvent(event.currentTarget, "mouseup", store.show);
    }
  });
  var onKeyDownProp = props.onKeyDown;
  var showOnKeyPressProp = useBooleanEvent(showOnKeyPress != null ? showOnKeyPress : canShow);
  var onKeyDown = useEvent(function (event) {
    onKeyDownProp == null ? void 0 : onKeyDownProp(event);
    if (!event.repeat) {
      canAutoSelectRef.current = false;
    }
    if (event.defaultPrevented) return;
    if (event.ctrlKey) return;
    if (event.altKey) return;
    if (event.shiftKey) return;
    if (event.metaKey) return;
    if (!store) return;
    var _store$getState3 = store.getState(),
      open2 = _store$getState3.open;
    if (open2) return;
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      if (showOnKeyPressProp(event)) {
        event.preventDefault();
        store.show();
      }
    }
  });
  var onBlurProp = props.onBlur;
  var onBlur = useEvent(function (event) {
    canAutoSelectRef.current = false;
    onBlurProp == null ? void 0 : onBlurProp(event);
    if (event.defaultPrevented) return;
  });
  var id = useId(props.id);
  var ariaAutoComplete = isAriaAutoCompleteValue(autoComplete) ? autoComplete : void 0;
  var isActiveItem = store.useState(function (state) {
    return state.activeId === null;
  });
  props = __spreadProps(__spreadValues({
    id: id,
    role: "combobox",
    "aria-autocomplete": ariaAutoComplete,
    "aria-haspopup": getPopupRole(contentElement, "listbox"),
    "aria-expanded": open,
    "aria-controls": contentElement == null ? void 0 : contentElement.id,
    "data-active-item": isActiveItem || void 0,
    value: value
  }, props), {
    ref: useMergeRefs(ref, props.ref),
    onChange: onChange,
    onCompositionEnd: onCompositionEnd,
    onMouseDown: onMouseDown,
    onKeyDown: onKeyDown,
    onBlur: onBlur
  });
  props = useComposite(__spreadProps(__spreadValues({
    store: store,
    focusable: focusable
  }, props), {
    // Enable inline autocomplete when the user moves from the combobox input
    // to an item.
    moveOnKeyPress: function moveOnKeyPress(event) {
      if (isFalsyBooleanCallback(_moveOnKeyPress, event)) return false;
      if (inline) setCanInline(true);
      return true;
    }
  }));
  props = usePopoverAnchor(__spreadValues({
    store: store
  }, props));
  return __spreadValues({
    autoComplete: "off"
  }, props);
});
var Combobox = forwardRef(function Combobox2(props) {
  var htmlProps = useCombobox(props);
  return createElement(TagName, htmlProps);
});
export { Combobox, useCombobox };